import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

const DAY = 24 * 60;

export const MAX_OFFSET_MINUTES = 366 * DAY;

const DIRECTION_OPTIONS = [
  { value: "before", label: "before" },
  { value: "after", label: "after" },
];

const UNIT_OPTIONS = [
  { value: "hours", label: "hours" },
  { value: "days", label: "days" },
];

export const offsetParts = (minutes) => {
  const magnitude = Math.abs(Number(minutes) || 0);
  const unit = magnitude > 0 && magnitude % DAY === 0 ? "days" : "hours";
  return {
    amount:
      magnitude === 0 ? "" : String(magnitude / (unit === "days" ? DAY : 60)),
    unit,
    direction: Number(minutes) < 0 ? "after" : "before",
  };
};

export const offsetMinutes = ({ amount, unit, direction }) => {
  const magnitude =
    Math.round(Math.abs(Number(amount)) * (unit === "days" ? DAY : 60)) || 0;
  return direction === "after" ? -magnitude : magnitude;
};

export const offsetsWithinAYear = (...minutes) =>
  minutes.every((value) => Math.abs(Number(value) || 0) <= MAX_OFFSET_MINUTES);

const ShowDetailOffset = ({ label, anchorName, minutes, onChange }) => {
  const [parts, setParts] = useState(() => offsetParts(minutes));

  useEffect(() => {
    if (offsetMinutes(parts) !== (Number(minutes) || 0))
      setParts(offsetParts(minutes));
  }, [minutes]);

  const setOffset = (changes) => {
    const next = { ...parts, ...changes };
    setParts(next);
    onChange(offsetMinutes(next));
  };

  return (
    <>
      <div className="series-price-change-offset">
        <input
          type="number"
          min="0"
          step="any"
          aria-label={`${label} offset`}
          className="series-edit-input"
          placeholder="0"
          value={parts.amount}
          onChange={(event) => setOffset({ amount: event.target.value })}
        />
        <select
          className="series-edit-input"
          aria-label={`${label} unit`}
          value={parts.unit}
          onChange={(event) => setOffset({ unit: event.target.value })}
        >
          {UNIT_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <select
          className="series-edit-input"
          aria-label={`${label} direction`}
          value={parts.direction}
          onChange={(event) => setOffset({ direction: event.target.value })}
        >
          {DIRECTION_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <span className="series-edit-hint">{anchorName}</span>
      </div>
      {!offsetsWithinAYear(minutes) && (
        <p className="series-schedule-error">
          Keep this within a year of {anchorName}.
        </p>
      )}
    </>
  );
};

ShowDetailOffset.propTypes = {
  label: PropTypes.string.isRequired,
  anchorName: PropTypes.string.isRequired,
  minutes: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
};

export default ShowDetailOffset;
